<div class="kpi-graph fade-in">
  <div class="kpi-graph-labels">
    <div class="kpi-graph-labels-title">
      <h1 class="kpi-graph-title">
        {{ "kpi.graph." + type + ".title" | translate }}
      </h1>
      <p class="kpi-graph-subtitle">
        {{ "kpi.graph." + type + ".subtitle" | translate }}
      </p>
    </div>
    <p class="kpi-graph-labels-total">
      {{ totalIndicator }}
    </p>
  </div>
  @if (!dataEmpty) {
    <div class="kpi-graph-content">
      @if (activeLabels[type]?.graph?.title) {
        <div class="kpi-graph-header">
          <h1 class="kpi-graph-title">
            {{ "kpi.graph." + type + ".dataTitle" | translate }}
          </h1>
          @if (activeLabels[type]?.graph?.subtitle) {
            <p class="kpi-graph-subtitle">
              {{ "kpi.graph." + type + ".dataSubtitle" | translate }}
            </p>
          }
        </div>
      }
      @if (graphEnabled) {
        <div class="kpi-graph-container">
          <plotly-plot
            [data]="data"
            [id]="'plot-graph-analytic-1'"
            [layout]="layout"
            [config]="config"
          ></plotly-plot>
        </div>
      }
      <div class="kpi-graph-indicators">
        @for (indicator of indicators; track indicator.key) {
          <div [class]="'kpi-graph-indicator ' + type">
            <svg-icon [name]="indicator.key"></svg-icon>
            <div class="kpi-graph-indicator-infos">
              <h2
                class="indicator-infos-count"
                [style.color]="getColor(indicator.key)"
              >
                {{ indicator.value }}
              </h2>
              <p class="indicator-infos-status">
                {{ "kpi.status." + indicator.key | translate }}
              </p>
              @if (activeDescriptions[indicator.key]) {
                <div class="indicator-infos-descriptions">
                  @if (!activeDescriptions[indicator.key].isList) {
                    <p class="indicator-infos-description">
                      {{
                        "kpi.status.descriptions." + indicator.key | translate
                      }}
                    </p>
                  }
                  @if (activeDescriptions[indicator.key].isList) {
                    <div>
                      @for (
                        descr of activeDescriptions[indicator.key].keys;
                        track $index
                      ) {
                        <p class="indicator-infos-description">
                          <span>{{
                            ("kpi.status.detail." + descr | translate) + ": "
                          }}</span>
                          {{ "kpi.status.descriptions." + descr | translate }}
                        </p>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
